// extracted by mini-css-extract-plugin
export default {"mainDiv":"OneImage_mainDiv__+240Q","image":"OneImage_image__93l9f","twoImage":"OneImage_twoImage__Xu6jk","TIdiv":"OneImage_TIdiv__d7YJi"};